import { handleActions } from "redux-actions";
import {
    clearKeywordScanStats,
    getKeywordScanStats,
    getKeywordScanStatsSuccess,
    getKeywordScanStatsError,
} from "modules/Metric/services/MetricKeywordScanStats/actions";

const initialState = {
    isLoading: false,
    data: null,
};

export const keywordScanStatsReducer = handleActions(
    {
        [clearKeywordScanStats]: () => ({ ...initialState }),
        [getKeywordScanStats]: (state) => ({
            ...state,
            isLoading: true,
        }),
        [getKeywordScanStatsSuccess]: (state, { payload }) => ({
            ...state,
            isLoading: false,
            data: payload,
        }),
        [getKeywordScanStatsError]: (state) => ({
            ...state,
            isLoading: false,
        }),
    },
    initialState
);
